import { useEffect, useState } from 'react'
import { IConsultationDetails } from '@/modules/MyCalls/types'
import { getConsultationDetails } from '@/modules/MyCalls/my-calls-services'

type UseConsultationDetailsReturn = {
  consultationDetails: IConsultationDetails | undefined
}

export const useConsultationDetails = (
  consultationId?: number,
): UseConsultationDetailsReturn => {
  const [consultationDetails, setConsultationDetails] = useState<
    IConsultationDetails | undefined
  >()

  useEffect(() => {
    const fetchConsultationDetails = async () => {
      if (!consultationId) {
        setConsultationDetails(null)
        return
      }

      try {
        const details = await getConsultationDetails(consultationId.toString())

        setConsultationDetails(details)
      } catch (err) {
        console.log(err)
        setConsultationDetails(null)
      }
    }

    fetchConsultationDetails()
    // eslint-disable-next-line
  }, [consultationId])

  return {
    consultationDetails,
  }
}
